import { render } from "./GameTitle.vue?vue&type=template&id=18023846&scoped=true"
const script = {}

import "./GameTitle.vue?vue&type=style&index=0&id=18023846&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18023846"]])

export default __exports__